import { render } from "./ButtonDelete.vue?vue&type=template&id=7e32cd3e&scoped=true"
import script from "./ButtonDelete.vue?vue&type=script&lang=js"
export * from "./ButtonDelete.vue?vue&type=script&lang=js"

import "./ButtonDelete.vue?vue&type=style&index=0&id=7e32cd3e&scoped=true&lang=css"

import exportComponent from "D:\\dev\\ai inventory\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e32cd3e"]])

export default __exports__